import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { gql } from '@apollo/client';
import { UserFragment } from '../../graphql/fragments/UserFragment';
export var startApplication = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation startApplication {\n    startApplication {\n      ...UserFragment\n    }\n  }\n  ", "\n"])), UserFragment);